import React, { FC } from "react";
import styles from "./styles.m.scss";

interface RadioButtonProps {
  checked: boolean;
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  label: string;
}

const RadioButton: FC<RadioButtonProps> = ({ checked, id, name, value, onChange, label }) => {
  return (
    <div className={styles.radioContainer}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className={styles.radioInput}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
